import React, {createContext, useContext, useState, useCallback, useMemo} from 'react';

interface CassandraSidePaneState {
    isOpen: boolean;
    toggle: () => void;
    close: () => void;
    activeChatId: string | null;
    setActiveChatId: (id: string | null) => void;
}

const CassandraSidePaneContext = createContext<CassandraSidePaneState | undefined>(undefined);

export function useCassandraSidePane() {
    const ctx = useContext(CassandraSidePaneContext);
    if (!ctx) {
        throw new Error('useCassandraSidePane must be used within a CassandraSidePaneProvider');
    }
    return ctx;
}

export function CassandraSidePaneProvider({children}: {children: React.ReactNode}) {
    const [isOpen, setIsOpen] = useState(false);
    const [activeChatId, setActiveChatId] = useState<string | null>(null);
    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
    const close = useCallback(() => setIsOpen(false), []);

    const value = useMemo(
        () => ({isOpen, toggle, close, activeChatId, setActiveChatId}),
        [isOpen, toggle, close, activeChatId, setActiveChatId]
    );

    return <CassandraSidePaneContext.Provider value={value}>{children}</CassandraSidePaneContext.Provider>;
}
